import { GrowthBook } from '@growthbook/growthbook';
import { env } from '@/env';

const growthbook = env.NEXT_PUBLIC_GROWTH_BOOK_KEY
    ? new GrowthBook({
          apiHost: 'https://api.insights.jucy.cloud',
          clientKey: env.NEXT_PUBLIC_GROWTH_BOOK_KEY,
          enableDevMode: env.NEXT_PUBLIC_ENV === 'dev',
          enabled: Boolean(env.NEXT_PUBLIC_GROWTH_BOOK_KEY),
      })
    : undefined;

growthbook?.loadFeatures().catch();

export default growthbook;
